// CartIcon (2026-07-07) — SVG Lucide "shopping-cart" unificado para toda la app.
//
// Reemplaza los emojis 🛒 / 🛍️ que se renderizaban distinto según OS:
// - macOS Apple Color Emoji: 🛒 se ve como bolsa dorada
// - Windows Segoe: carrito rojo
// - Android: bolsa con logo
//
// Con SVG inline, el ícono es idéntico en todos los devices, controlable con
// currentColor y tamaño. Aria-hidden porque el botón contenedor ya tiene aria-label.

export default function CartIcon({ size = 22, strokeWidth = 2, className = '', style = {} }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
  )
}
